import { Table } from "containers/Table";
import { IColum } from "containers/Table/interfaces";
import {
  ButtonsContainer,
  Container,
  ContainerResumo,
  Header,
  ItemResumo,
  TextoHeader,
} from "./style";
import { IDadosLoteLicenciamento } from "../../interfaces/IDadosLoteLicenciamento";
import { IListaLicenciamentos } from "../../interfaces/IListaLicenciamentos";
import { PrimaryButton } from "components/Button/style";
import { FaDownload, FaFileAlt, FaFileSignature } from "react-icons/fa";
import { ModalCheckbox } from "../ModalCheckbox";
import { ModalAvisoExportar } from "../ModalAvisoExportar";
import { StatusEmissaoLicenciamento } from "./containers/StatusEmissaoLicenciamento";
import { formatarCpfCnpj } from "_utils/CpfCnpj";
import { Col, Row } from "react-bootstrap";
import { converterDataBr } from "_utils/Data";
import { useSolicitacaoLicenciamentos } from "hooks/useSolicitacaoLicenciamentos";

interface IProps {
  clearRows: boolean;
  setRowsSelected: (ids: number[]) => void;
  lista: IListaLicenciamentos[];
  selectedRows: any[];
  dadosLote: IDadosLoteLicenciamento;
  onClickEmissaoManual: () => void;
  disabledEmissaoManual: boolean;
  onClickReemitir: () => void;
  disabledReemitir: boolean;
  onClickDownload: () => void;
  showModalDownload: boolean;
  onConfirmModalDownload: () => void;
  handleCloseModalDownload: () => void;
  showModalExportar: boolean;
  onConfirmModalExportar: () => void;
  handleCloseModalExportar: () => void;
  onClickExportar: () => void;
  onChangePage: (page: number) => void;
  onChangeRowsPerPage: (rows: number) => void;
  rowsPerPage: number;
  totalRows: number;
}

export function ListagemDetalhesLicenciamento({
  clearRows,
  setRowsSelected,
  selectedRows,
  lista,
  dadosLote,
  onClickEmissaoManual,
  disabledEmissaoManual,
  onClickReemitir,
  disabledReemitir,
  onClickDownload,
  showModalDownload,
  onConfirmModalDownload,
  handleCloseModalDownload,
  showModalExportar,
  onConfirmModalExportar,
  handleCloseModalExportar,
  onClickExportar,
  onChangePage,
  onChangeRowsPerPage,
  rowsPerPage,
  totalRows,
}: IProps) {
  const { onClickProcesso } = useSolicitacaoLicenciamentos();

  const columns: IColum<IListaLicenciamentos>[] = [
    {
      name: "ID Processo",
      selector: ({ idProcesso }: IListaLicenciamentos) => (
        <div
          className="link-primary"
          style={{ cursor: "pointer" }}
          onClick={() => {
            onClickProcesso(idProcesso);
          }}
        >
          {idProcesso}
        </div>
      ),
    },
    {
      name: "Placa",
      selector: ({ placa }: IListaLicenciamentos) => placa ?? "--",
    },
    {
      name: "Renavam",
      selector: ({ renavam }: IListaLicenciamentos) => renavam ?? "--",
    },
    {
      name: "Chassi",
      selector: ({ chassi }: IListaLicenciamentos) => chassi ?? "--",
      width: "200px",
    },
    {
      name: "Data de emissão",
      selector: ({ dataEmissao }: IListaLicenciamentos) =>
        dataEmissao ? converterDataBr(dataEmissao) : "--",
      width: "200px",
    },
    {
      name: "Observação",
      selector: ({ observacao }: IListaLicenciamentos) =>
        observacao && observacao != "" ? observacao : "--",
      width: "200px",
    },
    {
      name: "Status emissão",
      selector: ({ statusEmissao }: IListaLicenciamentos) =>
        statusEmissao ? (
          <StatusEmissaoLicenciamento statusEmissao={statusEmissao} />
        ) : (
          "--"
        ),
      width: "200px",
    },
  ];

  return (
    <Container>
      <Header>
        <TextoHeader>
          Detalhes Emissão de Licenciamentos - ID {dadosLote.id}
        </TextoHeader>
      </Header>
      <hr />
      <ContainerResumo>
        <Row>
          <Col lg="5">
            <ItemResumo>
              Empresa: <strong>{dadosLote.nomeEmpresa}</strong>
            </ItemResumo>
            <ItemResumo>
              CPF/CNPJ:{" "}
              <strong>
                {dadosLote.cpfCnpj ? formatarCpfCnpj(dadosLote.cpfCnpj) : "--"}
              </strong>
            </ItemResumo>
          </Col>
          <Col lg="2">
            <ItemResumo>
              Exercício: <strong>{dadosLote.exercicio}</strong>
            </ItemResumo>
            <ItemResumo>
              UF: <strong>{dadosLote.uf}</strong>
            </ItemResumo>
          </Col>
        </Row>

        <ItemResumo>
          Descrição: <strong>{dadosLote.descricao}</strong>
        </ItemResumo>
      </ContainerResumo>
      <Table
        keyField="_key"
        columns={columns}
        data={lista.map((item, index) => ({
          ...item,
          _key: `${item.idProcesso}-${index}`,
        }))}
        loading={false}
        possuiTooltip={false}
        pagination={true}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        selectableRows
        setRowsSelected={setRowsSelected}
        headerFixo
        exportExcel
        buttonExportVariant="secondary"
        textoBotaoExportarExcel="Exportar CRLV"
        iconeDownloadBotaoExportarExcel="excel"
        handleExport={onClickExportar}
        widthBotaoExportarExcel={160}
        clearSelectedRows={clearRows}
        toolsHeader={
          <ButtonsContainer>
            <PrimaryButton
              variante="primary"
              outline
              onClick={onClickEmissaoManual}
              disabled={disabledEmissaoManual}
            >
              Emissão manual <FaFileSignature />
            </PrimaryButton>

            <PrimaryButton
              variante="primary"
              outline
              onClick={onClickReemitir}
              disabled={disabledReemitir}
              title={"Emitir novamente todas as placas com status de Falha"}
            >
              Reemitir <FaFileAlt />
            </PrimaryButton>

            <PrimaryButton onClick={onClickDownload}>
              Download CRLV <FaDownload />
            </PrimaryButton>
          </ButtonsContainer>
        }
      />
      <ModalCheckbox
        showModal={showModalDownload}
        handleClose={handleCloseModalDownload}
        onConfirm={onConfirmModalDownload}
        tipoModal="download"
      />
      <ModalAvisoExportar
        showModalExportar={showModalExportar}
        handleCloseModalExportar={handleCloseModalExportar}
        onConfirmModalExportar={onConfirmModalExportar}
      />
    </Container>
  );
}
